export default {
  appTokenEndpoint: `${window.location.origin}/api/v1/auth/token`,
};
